import type {AppThunk} from '../../../actions/types'
import {getAgentsArg} from '../../../rest/agents'
import {agentsProjectsArg} from '../../../rest/projects'
import {restApi} from '../../../services/rest'
import type {AgentRequestOptions} from '../../../types'

export const preloadAgents =
  (locator: string, additionalFields?: AgentRequestOptions): AppThunk =>
  dispatch => {
    dispatch(restApi.endpoints.getPoolPermissions.initiate())
    dispatch(restApi.endpoints.getAllProjectsNormalized.initiate(agentsProjectsArg))
    dispatch(
      restApi.endpoints.getAllAgentsNormalized.initiate(getAgentsArg(locator, additionalFields)),
    )
  }
